import {Grant, GrantCreate} from "./@types/Grant";
export class GrantRepository {
    private httpService: IHttpService;
    private baseUrl: string;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/grants';
    }
    async getAll(): Promise<Grant[]>{
        const response = await this.httpService.get<TKResponse<Grant[]>>(this.baseUrl);
        return response.data
            .map(item => ({...item, id: item.grant_id}))
            .sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
    }
    async getOne(id: number): Promise<Grant> {
        const response = await this.httpService.get<TKResponse<Grant>>(`${this.baseUrl}/${id}`);
        return {...response.data, id: response.data.grant_id};
    }
    async create(data: GrantCreate): Promise<Grant> {
        const response = await this.httpService.post<TKResponse<Grant>, GrantCreate>(this.baseUrl, {data});
        return response.data;
    }
    async update(id: number, data: GrantCreate): Promise<Grant> {
        const response = await this.httpService.patch<TKResponse<Grant>, GrantCreate>(`${this.baseUrl}/${id}`, {data});
        return response.data;
    }
    async delete(id: number): Promise<void> {
        return await this.httpService.delete(`${this.baseUrl}/${id}`);
    }
}

